module.exports = __webpack_public_path__ + "static/img/1-2.9138c2e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/1-2.png
// module id = ADN0
// module chunks = 0